import { Col, Modal, Row } from 'antd';
import * as React from 'react';
import { Provider } from 'unstated';

import GeneralSettingsCol from './GeneralSettingsCol';
import { StateContainer } from './StateContainer';
import ValueSettingsCol from './ValueSettingsCol';

interface IVoucherDetailProps {
    voucher: GQL.IVoucher;
    domain: string;
    onSave: (voucher: GQL.IVoucher) => void;
    onCancel: () => void;
}

interface IVoucherDetailState {
    confirmLoading: boolean;
}

export default class VoucherDetail extends React.Component<IVoucherDetailProps, IVoucherDetailState> {
    private voucherContainer: StateContainer;

    public constructor(props: IVoucherDetailProps) {
        super(props);
        this.voucherContainer = new StateContainer({
            voucher: props.voucher,
        });

        this.save = this.save.bind(this);
    }

    private canSave: boolean = true;
    private checkCanSaveNo: number = 0;

    public render() {
        const { voucher } = this.voucherContainer.state;

        return (
            <Provider>
                <Modal
                    maskClosable={false}
                    title={
                        voucher == undefined || voucher.id == undefined
                            ? 'New Voucher'
                            : `Voucher ${voucher.title}`
                    }
                    visible={true}
                    cancelText={'Close'}
                    okText={'Save changes'}
                    onOk={this.save}
                    onCancel={() => this.props.onCancel()}
                    confirmLoading={this.state && this.state.confirmLoading || false}
                >
                    <Row>
                        <Col md={11}>
                            <GeneralSettingsCol container={this.voucherContainer} domain={this.props.domain} allChangeStored={(stored) => this.canSave = stored} />
                        </Col>
                        <Col md={11} offset={1}>
                            <ValueSettingsCol container={this.voucherContainer} />
                        </Col>
                    </Row>
                </Modal>
            </Provider>
        );
    }

    private async save() {
        // Protože všechny změny se kvůli přerendrovávání formuláře zapisují pomalu, je potřeba testovat, jestli už jsou všechny změny zapsané
        if (!this.canSave) {
            this.checkCanSaveNo++;
            console.log('Setting timer', this.checkCanSaveNo);
            if (this.checkCanSaveNo < 20) {
                this.setState({ confirmLoading: true })
                setTimeout(this.save, 1000);
            }
            return;
        }
        this.checkCanSaveNo = 0;
        const errors = await this.voucherContainer.validate(); // TODO
        let anyError = false;

        for (const key of Object.keys(errors)) {
            if (errors[key] != undefined) {
                anyError = true;
            }
        }

        if (!anyError) {
            const voucher = await this.voucherContainer.getVoucher();
            this.props.onSave(voucher);
        } else {
            console.log('there is error, can not save', errors);
        }
        this.setState({ confirmLoading: false });
    }
}



// WEBPACK FOOTER //
// ./src/scenes/Vouchers/VoucherDetail/VoucherDetail.tsx